/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.14.0
 */

import React from 'react';

import Textarea from '../../../components/common/Textarea/Textarea';
import FormField, { IFormFieldProps } from './FormField';

interface IFormFieldTextareaProps {
    onChangeTextarea?: (event: React.FormEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLTextAreaElement>) => void;
}

type TFormFieldTextarea = IFormFieldProps & React.HTMLProps<HTMLTextAreaElement> & IFormFieldTextareaProps;

const FormFieldTextarea = (props: TFormFieldTextarea) => (
    <FormField {...props}>
        {({ field, disabled, dataName, required, label, labelHint, kind }) => {
            return (
                <Textarea
                    {...field}
                    dataName={dataName}
                    disabled={disabled}
                    kind={kind}
                    label={label}
                    labelHint={labelHint}
                    maxLength={props.maxLength}
                    required={required}
                    rows={props.rows}
                    value={field.value}
                    onChange={(data) => {
                        field.onChange(data);
                        if (props.onChangeTextarea) {
                            props.onChangeTextarea(data);
                        }
                    }}
                />
            );
        }}
    </FormField>
);

export default FormFieldTextarea;
